<template>
    <div>
      <span class="span-title" />
      <span v-if="hint" class="col-12 note p-1">{{ hint }}</span>
        <!-- Custom "Add file" button -->
        <div class="d-flex align-items-center justify-content-between pb-1" >
            <span style="font-style: italic">{{ file?.name || $t('common.select_file') }}</span>
            <button
                class="btn btn-outline-primary btn-sm"
                type="button"
                @click="triggerFileInput"
            >
                {{ $t('common.add') }} {{ extension }}
            </button>
        </div>

        <input
            ref="fileInput"
            type="file"
            class="visually-hidden"
            :accept="extension"
            :placeholder="label + ' ' + $t('import_file_wizard.max_shapefile_size')"
            @change="updateValue($event)"
        />
    </div>
    <div>
      <span v-if="invalidFile" class="subtitle" style="color: red">
        {{ $t('import_file_wizard.shape_file_too_big') }}
      </span>
    </div>
</template>
<script>
export default {
    name: 'ShapeFilePicker',
    props: {
        label: {
            type: String,
            required: true
        },
        extension: {
            type: String,
            required: true
        },
        hint: {
            type: String,
            required: false,
            default: null
        }},
    data: function () {
        return {
            invalidFile: false,
            file: null
        }
    },
    emits: ['fileSelected'],
    methods: {

        triggerFileInput() {
            this.$refs.fileInput?.click();
        },

        updateValue: function (value) {
            if (value !== null) {
                let file = value.target.files[0]
                let maxFileSize = 6 * 1024 * 1024 // 6 MB
                this.invalidFile = file.size > maxFileSize
                if (this.invalidFile) {
                    file = null
                    this.$refs['file-input'].reset()
                }
                this.file = file
                this.$emit('fileSelected', file)
            } else {
                this.$emit('fileSelected', null)
            }
        }
    }
}
</script>


